import { render, staticRenderFns } from "./TextPathImportModal.vue?vue&type=template&id=b7073b8c&scoped=true"
import script from "./TextPathImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextPathImportModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextPathImportModal.vue?vue&type=style&index=0&id=b7073b8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7073b8c",
  null
  
)

export default component.exports